import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(() => ({
  container: {
    marginBottom: "35px"
  },
  section: { padding: "0 30px 35px" },
  footer: {
    display: "flex",
    alignItems: "center",
    flex: "1",
    maxHeight: "100px",
    padding: "0 30px",
    borderTop: "1px solid #F2F2F2",
    "& > div": {
      flex: 1
    },
    "& > div:last-child": {
      flex: 2
    }
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }
}))

export default styles
